<div class="document-wrapper">
    <h2>Documentación <button class="add-record" (click)="addEmpresaDocumentation()" type="button">+</button></h2>
    <div class="doc-list-wrapper">
        <!-- <mat-progress-spinner *ngIf="isloading" class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
        </mat-progress-spinner> -->
        <div *ngIf="!isloading">
            <div *ngFor="let item1 of docEmpresaGroupList; let i = index" class="doc-list-loop">
                <h3>{{item1.tipo}}</h3>
                <div class="doc-list-loop-outer">                
                    <div *ngFor="let item2 of item1.docEmpresaList; let j = index"   class="doc-item">
                        <div class="img-block" *ngIf="item2.tipoDocumento == 'DOC'">
                            <mat-icon>insert_drive_file</mat-icon>
                        </div>
                        <div class="img-block" *ngIf="item2.tipoDocumento == 'PDF'">
                            <mat-icon>picture_as_pdf</mat-icon>
                        </div>
                        <div class="img-block" *ngIf="item2.tipoDocumento != 'PDF' && item2.tipoDocumento != 'DOC'">
                            <mat-icon>image</mat-icon>
                        </div>
                        <div class="cont-block">
                            <span>{{item2.fecha? (item2.fecha | date :'dd/MM/yyyy') : ''}}</span>
                            <p>{{item2.descripcion? item2.descripcion : ""}}</p>
                        </div>
                        <button type="button" [matMenuTriggerFor]="docMoreMenu" class="more">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #docMoreMenu="matMenu">                            
                            <a mat-menu-item *ngIf="item2.tipoDocumento !== 'DOC'" (click)="ViewDocument(item2)">
                                <span>Ver</span>
                            </a>
                            <a mat-menu-item (click)="downloadDocument(item2)">
                                <span>Descargar</span>
                            </a>
                            <a mat-menu-item (click)="deleteDocument(item2)">
                                <span>Eliminar</span>
                            </a>
                        </mat-menu>
                    </div>
                </div>
            </div>        
        </div>
    </div>
</div>